/**
 * @generated SignedSource<<9ba88cde85491eec9870902df96def81>>
 * @relayHash 95e90ebeebc33fb4193641faa01c7d28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 51ba935dd2a63cc3f7e0f9ed6322d6308c1fe5a956c0ea38b7bd88929a1c328c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraFieldSetPreferencesMutationInput = {
  nodes?: ReadonlyArray<JiraUpdateFieldSetPreferencesInput> | null | undefined;
};
export type JiraUpdateFieldSetPreferencesInput = {
  fieldSetId: string;
  isFrozen?: boolean | null | undefined;
  width?: number | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type main_updateFieldSetPreferencesMutation$variables = {
  cloudId: string;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  input: JiraFieldSetPreferencesMutationInput;
  settings?: JiraIssueSearchSettings | null | undefined;
  viewId?: string | null | undefined;
};
export type main_updateFieldSetPreferencesMutation$data = {
  readonly jira: {
    readonly updateUserFieldSetPreferences: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
      readonly view: {
        readonly isViewConfigModified?: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type main_updateFieldSetPreferencesMutation = {
  response: main_updateFieldSetPreferencesMutation$data;
  variables: main_updateFieldSetPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "context",
    "variableName": "context"
  },
  {
    "kind": "Variable",
    "name": "fieldSetPreferencesInput",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "viewId",
    "variableName": "viewId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "success"
},
v7 = {
  "kind": "ScalarField",
  "name": "message"
},
v8 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v9 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "settings",
          "variableName": "settings"
        }
      ],
      "kind": "ScalarField",
      "name": "isViewConfigModified"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_updateFieldSetPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraFieldSetPreferencesUpdatePayload",
            "kind": "LinkedField",
            "name": "updateUserFieldSetPreferences",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "view",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_updateFieldSetPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraFieldSetPreferencesUpdatePayload",
            "kind": "LinkedField",
            "name": "updateUserFieldSetPreferences",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "view",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "51ba935dd2a63cc3f7e0f9ed6322d6308c1fe5a956c0ea38b7bd88929a1c328c",
    "metadata": {},
    "name": "main_updateFieldSetPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b60b49cc5a0a1e4323f0c3ed83da042f";

export default node;
